// extracted by mini-css-extract-plugin
export default {"close":"_5PbEg"};